import React from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { injectIntl } from 'react-intl'

const HealthcareTeam = ({intl, data}) => (
    <Grid
        data-testid="healthcare-team"
        item style={{paddingBottom: '12px'}}>
        <Typography>
            {intl.formatMessage({id: 'app.dashboard.healthcareTeam'})}
        </Typography>
        {data && (data.creatorFirstName || data.creatorLastName) && (
            <Typography variant="body2">
                {data.creatorFirstName}{' '}{data.creatorLastName}
            </Typography>)}
        {data && data.creatorFirstName && (
            <Typography variant="body2">
                {data.sponsorName}
            </Typography>)}
    </Grid>
)

export default injectIntl(HealthcareTeam)
